<script lang="ts" setup>
import { useFormStore } from "@stores/form.store"
import { computed, onBeforeMount, onDeactivated, ref } from "vue"

const { snapshot, fetchCSTBRecord } = useFormStore()

function handleBeforeUnload(e: BeforeUnloadEvent) {
    e.preventDefault()
}

onBeforeMount(() => {
    // window.addEventListener("beforeunload", handleBeforeUnload)
})
onDeactivated(() => {
    window.removeEventListener("beforeunload", handleBeforeUnload)
})

const isDev = computed(() => {
    return import.meta.env.MODE === "development"
})
const open = ref(false)
</script>
<template>
    <div class="form-page" v-if="!fetchCSTBRecord.isFetching">
        <FormStepper />
        <div
            v-if="isDev"
            class="bg-white p-4 rounded-md shadow-md absolute top-0 left-0 overflow-y-auto m-4 flex flex-col gap-4"
            style="max-height: 50%"
        >
            <BaseButton
                :icon="`pi pi-${open ? 'minus' : 'plus'}`"
                class="!min-h-8 ml-auto max-w-8 max-h-8"
                rounded
                severity="secondary"
                @click="open = !open"
            />
            <pre v-if="open">{{ snapshot }}</pre>
        </div>
        <KeepAlive>
            <StepOne v-if="snapshot.matches('Step1')" />
            <StepTwo v-else-if="snapshot.matches('Step2')" />
            <StepThree v-else-if="snapshot.matches('Step3')" />
            <StepFinally v-else-if="snapshot.matches('Finally')" />
        </KeepAlive>
        <WhyParticipateSection
            v-if="!snapshot.matches('Finally')"
            class="!p-0"
        />
    </div>
    <div v-else class="form-page">
        <BaseSkeleton width="100%" height="8rem"></BaseSkeleton>
        <BaseSkeleton width="100%" height="50rem"></BaseSkeleton>
        <BaseSkeleton width="100%" height="5rem"></BaseSkeleton>
    </div>
</template>

<style scoped>
.form-page {
    display: flex;
    flex-direction: column;
    gap: 3.5rem;
    max-width: 61.5rem;
    width: 100%;
    margin: 0 auto;
}
</style>
